/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RematchLineItems202Response
 */
export interface RematchLineItems202Response {
    /**
     * Comparison ID to poll for results
     * @type {number}
     * @memberof RematchLineItems202Response
     */
    comparisonId: number;
    /**
     * Status message
     * @type {string}
     * @memberof RematchLineItems202Response
     */
    message: string;
}

/**
 * Check if a given object implements the RematchLineItems202Response interface.
 */
export function instanceOfRematchLineItems202Response(value: object): value is RematchLineItems202Response {
    if (!('comparisonId' in value) || value['comparisonId'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function RematchLineItems202ResponseFromJSON(json: any): RematchLineItems202Response {
    return RematchLineItems202ResponseFromJSONTyped(json, false);
}

export function RematchLineItems202ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RematchLineItems202Response {
    if (json == null) {
        return json;
    }
    return {
        
        'comparisonId': json['comparisonId'],
        'message': json['message'],
    };
}

export function RematchLineItems202ResponseToJSON(json: any): RematchLineItems202Response {
    return RematchLineItems202ResponseToJSONTyped(json, false);
}

export function RematchLineItems202ResponseToJSONTyped(value?: RematchLineItems202Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'comparisonId': value['comparisonId'],
        'message': value['message'],
    };
}

